<template>
  <div
    class="base-type-edit"
    :class="baseTypeThemeClass"
    :style="baseTypeThemeStyle"
  >
    <BaseTypePageCap
      :base-type="baseType"
      :title="title"
      :subtitle="subtitle"
      :show-back-link="showBackLink"
      :in-review="inReview"
    >
      <template v-if="$slots.title" #title>
        <slot name="title" />
      </template>
      <template v-if="$slots['header-actions']" #header-actions>
        <slot name="header-actions" />
      </template>
    </BaseTypePageCap>
    <div class="base-type-edit__body">
      <slot />
    </div>
  </div>
</template>

<script>
import BaseTypePageCap from "@/components/base_type/BaseTypePageCap.vue";
import {getBaseTypeThemeClass, getBaseTypeThemeStyle} from "@/utils/baseTypeTheme";

export default {
  name: 'BaseTypeEditShell',
  components: {
    BaseTypePageCap,
  },
  props: {
    baseType: {
      type: String,
      required: true,
      validator: (value) => ['accommodations', 'offers', 'events', 'discover'].includes(value),
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: null,
    },
    showBackLink: {
      type: Boolean,
      default: true,
    },
    inReview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    baseTypeThemeClass() {
      return getBaseTypeThemeClass(this.baseType)
    },
    baseTypeThemeStyle() {
      return getBaseTypeThemeStyle(this.baseType)
    },
  },
}
</script>
